<template>
  <b-container fluid>
    <h3>{{ $t('Datenpaket') }}</h3>
    <b-form inline class="mt-3">
      <b-form-select
        v-model="paketId"
        :options="pakete"
        text-field="text"
        value-field="value"
        name="datenpaket"
        class="custom-select mb-3"
      ></b-form-select>
    </b-form>
    <div v-if="paketId !== 0">
      <p v-html="paketInfos"></p>
    </div>
<!--
    <div v-if="paketId !== 1">
      <p v-html="paketInfos"></p>
    </div>
    <div v-if="paketId === 1">
      <h3>{{ $t('Kriterien') }}</h3>
      <b-card v-for="kriterium in kriterien" v-bind:key="kriterium.id" no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab" :ref="kriterium.id">
          <b-btn
            block
            href="#"
            v-b-toggle="kriterium.id.toString()"
            variant="primary"
          >{{ kriterium.code[$i18n.locale] }}</b-btn>
        </b-card-header>
        <b-collapse :id="kriterium.id.toString()" accordion="kriterien" role="tabpanel">
          <b-card-body
            v-html="'<h3>' + kriterium.name[$i18n.locale] + '</h3>' + kriterium.text[$i18n.locale]"
          ></b-card-body>
        </b-collapse>
      </b-card>
      <h3>{{ $t('Rechtliches') }}</h3>
      <b-link
        href="/resources/1/uploads/Nutzungsbedingungen_Datenpakete.pdf"
        target="_blank"
      >{{ $t('Nutzungsbedingungen') }}</b-link>
    </div>
-->
  </b-container>
</template>

<script>
import { i18n } from "../../main";
export default {
  name: "kriterien",
  data() {
    return {
      paketId: 0
    };
  },
  computed: {
    pakete() {
      let opt = [];
      for (let paket of this.$store.state.datenpaketeStore.pakete) {
        opt.push({ text: paket.name[i18n.locale], value: paket.id });
      }
      return opt;
    },
    paketInfos() {
      console.log(this.paketId);
      let paket = this.$store.state.datenpaketeStore.pakete.find(obj => {
        return obj.id === this.paketId;
      });
      return paket.infos[i18n.locale];
    },
/*
    kriterien() {
      return this.$store.state.datenpaketeStore.kriterien.list;
    }
*/
  },
  methods: {
    async init() {
      await this.$store.dispatch("loadPakete");
      if (this.pakete.length)
        this.paketId = this.pakete[0].value;
    },
/*
    setLatestPaketID() {
      // paketid wurde in computed pakete mitgeführt.. sideeffect ..
      let latestPaket = this.$store.state.datenpaketeStore.pakete[
        this.$store.state.datenpaketeStore.pakete.length - 1
      ];
      this.paketId = latestPaket.id;
    },
    scrollTo(ref) {
      let element = this.$refs[ref][0];
      element.scrollIntoView();
    },
    setMaxPaketID() {
      const max = this.pakete.reduce((prev, current) => (prev.id > current.id) ? prev : current)
      this.paketId = max.id
    }
*/
},
  created() {},
  mounted() {
    let self = this;
    this.$nextTick(async function() {
      self.init();
      // await self.$store.dispatch("loadKriterien");
      // await self.$store.dispatch("loadPakete");
      // self.setMaxPaketID();
    });
  },
  updated() {},
  components: {}
};
</script>